import React from "react";

function MediaEyeGlyph({ size = 20 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

const linkBaseStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  textDecoration: "none",
  lineHeight: 0,
  verticalAlign: "middle",
};

const btnBaseStyle = {
  cursor: "pointer",
  border: "none",
  background: "none",
  padding: "4px 6px",
  minHeight: 36,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  touchAction: "manipulation",
  lineHeight: 0,
};

/** Opens `href` in a new tab; blue outline eye (no “View” text). */
export function ViewMediaEyeAnchor({
  href,
  color = "#0000aa",
  size = 20,
  ariaLabel = "View",
  title = "View in new tab",
  style,
}) {
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel}
      title={title}
      style={{ ...linkBaseStyle, color, ...style }}
    >
      <MediaEyeGlyph size={size} />
    </a>
  );
}

/**
 * Opens URL in a new tab via `window.open` (use when the href is normalized
 * elsewhere or must not be a literal `href`, e.g. blob URLs).
 */
export function ViewMediaEyeOpenButton({
  openUrl,
  color = "#0000aa",
  size = 20,
  ariaLabel = "View document",
  title = "View document in new tab",
  style,
}) {
  if (!openUrl) {
    return <span style={{ color: "#999", fontSize: 12 }}>—</span>;
  }
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      title={title}
      onClick={() => window.open(openUrl, "_blank", "noopener,noreferrer")}
      style={{ ...btnBaseStyle, color, ...style }}
    >
      <MediaEyeGlyph size={size} />
    </button>
  );
}

/** Same eye as anchor but uses `onClick` (e.g. already-resolved absolute URL). */
export function ViewMediaEyeButton({
  onClick,
  color = "#0000aa",
  size = 20,
  ariaLabel = "View document",
  title = "View document",
  style,
}) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      title={title}
      onClick={onClick}
      style={{ ...btnBaseStyle, color, ...style }}
    >
      <MediaEyeGlyph size={size} />
    </button>
  );
}
